import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Dropdown, Button } from 'react-bootstrap';
import { MdMoreHoriz } from 'react-icons/md';
import { IoIosCheckmarkCircle } from "react-icons/io";
// import OrderModal from '../../../Modals/OrderModal/OrderModal';
import OrderModal from '../OrderModal/OrderModal';
import './OrderListItem.scss';
import i18n from 'i18next';

function OrderListItem(props) {
    const { order, orderMeta, orderRowsMeta, asOrderSelect, selectedOrder, onSelectOrder } = props;
    const [ modalShow, setModalShow ] = useState(false);
    const { t } = useTranslation();
    const { language } = i18n;

    const getStatus = (status) => {
		if (orderMeta && orderMeta.statuses) {
            let statuses;

            if (language === 'fi') {
                statuses = orderMeta.statuses.partner;
            } else {
                statuses = [
                    ...orderMeta.statuses.app.General,
                    ...orderMeta.statuses.app.Other,
                    ...orderMeta.statuses.app.Payment
                ];
            }

			statuses.forEach((metaStatus)=>{
				if (metaStatus.id === status) {
					status = metaStatus.text;
				}
			})
        }
		return status;
    };

    const isSelectedOrder = selectedOrder && selectedOrder === order.orderID;

    return (
        <React.Fragment>
            <div className="DataListItem row align-items-center" key={order.orderID} style={{paddingTop: '20px', paddingBottom: '20px'}}>
                <div className="col-lg-2">
                    <span style={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => setModalShow(true)}>{order.name}</span>
                </div>
                <div className="col-lg-2 text-left">
                    <IoIosCheckmarkCircle className="green" style={{marginRight: '10px', position: 'relative', top: '-2px'}} />{getStatus(order.status)}
                </div>
                <div className="col-lg-2 text-left">
                    {parseFloat(order.totalConfirmed ? order.totalConfirmed : '0').toFixed(2)} €
                </div>
                <div className="col-lg-2 text-left">
                    {moment(order.timeCreated).format('DD.MM.YYYY - HH:mm') || ''}
                </div>
                <div className="col-lg-2 text-left">
                    {t('orders.order_rows')}: <strong>{order.orderRowsTotal}</strong>
                </div>
                {asOrderSelect ?
                    <div className="col">
                        <Button
                            onClick={() => onSelectOrder(order.orderID)}
                            variant={isSelectedOrder ? 'primary' : 'outline-primary'}
                            active={isSelectedOrder}
                        >
                            {isSelectedOrder ? t('general.selected') : t('general.select')}
                        </Button>
                    </div>
                : null}
                <div className="col text-right">
                    <Dropdown>
                        <Dropdown.Toggle as="span">
                            <MdMoreHoriz style={{fontSize: '18px'}} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight>
                            <Dropdown.Item onClick={() => setModalShow(true)}>
                                {t('orders.show_details')}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <OrderModal
                    show={modalShow}
                    order={order}
                    orderMeta={orderMeta}
                    orderRowsMeta={orderRowsMeta}
                    onHide={() => setModalShow(false)}
                />
            </div>
        </React.Fragment>
    )
}

export default OrderListItem;